export const COLUMS_IMAGE = [
  { name: 'Type', widthCol: '40%' },
  { name: 'Size', widthCol: '30%' },
  { name: 'Consumed', widthCol: '30%' }
]
